import { render, staticRenderFns } from "./DocumentVerification.vue?vue&type=template&id=2872551e"
import script from "./DocumentVerification.vue?vue&type=script&lang=js"
export * from "./DocumentVerification.vue?vue&type=script&lang=js"
import style0 from "./DocumentVerification.vue?vue&type=style&index=0&id=2872551e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports